import type { FreelancerSignUpLocales } from '../types';

const freelancerSignUpLocales: FreelancerSignUpLocales = {
  agreeWith: 'I agree to',
  alreadyHaveAccount: 'Already have a Tadaah account?',
  howDoYouKnowTadaah: 'How do you know Tadaah?',
  noAccount: 'No account yet?',
  signupError: 'Error during signup',
  signupSuccess: 'Account created!',
  title: 'Sign Up',
  toLogin: 'to login',
  toSignup: 'to sign up',
  welcome: 'Welcome',
};

export default freelancerSignUpLocales;
